import React from 'react';
import { Route, Switch, Link } from 'react-router-dom';

import { FormGroup, Text } from 'components/FormElements/';
import Dashboard from './dashboard';
import Edit from './edit';

const Email = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}/edit/:id`} component={Edit}/>
      <Route path={`${match.path}/new`} component={Edit}/>
      <Route path={`${match.path}`} component={Dashboard}/>
    </Switch>
  )
};

module.exports = Email;



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/emails/index.js